import { render } from "./Notifica.vue?vue&type=template&id=4c7f4322&ts=true"
import script from "./Notifica.vue?vue&type=script&lang=ts"
export * from "./Notifica.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__